import Immutable from 'immutable';
import {deserializeColorMode} from '~/data/deserializers/base';
import Color from '~/data/records/Color';
import SpotColor from '~/data/records/SpotColor';
import {
  COLOR_MODES,
  MONOCHROME_COLOR_MAXIMUM
} from '~/constants/UploadConstants';

function deserializeSpotColors({imageType, colors}) {
  const spotColors = Immutable.Map(colors).reduce(
    (list, paletteHex, originalHex) => {
      return list.push(
        new SpotColor({
          original: new Color({hex: originalHex}),
          palette: new Color({hex: paletteHex})
        })
      );
    },
    Immutable.List()
  );

  if (imageType === COLOR_MODES.MONOCHROME) {
    return spotColors
      .groupBy(c => c.palette)
      .take(MONOCHROME_COLOR_MAXIMUM)
      .valueSeq()
      .flatten(true)
      .toList();
  }

  return spotColors;
}

export function deserializeBackgroundColor({background}) {
  return background ? new Color({hex: background}) : null;
}

export function deserializeOriginalImageDimensions({dimensions}) {
  const [originalImageWidth, originalImageHeight] = dimensions
    ? [dimensions.width, dimensions.height]
    : [null, null];
  return {originalImageWidth, originalImageHeight};
}

export function deserializeUpload(data) {
  const {url} = data;
  return {
    colorMode: deserializeColorMode(data),
    spotColors: deserializeSpotColors(data),
    backgroundColor: deserializeBackgroundColor(data),
    ...deserializeOriginalImageDimensions(data),
    url
  };
}
